import { render } from "./SelosCard.vue?vue&type=template&id=efb88726"
import script from "./SelosCard.vue?vue&type=script&lang=js"
export * from "./SelosCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__